import { FilterItemStrings } from "pages/AccessPermissionManagement/CustomFilter/types";
import { atom, DefaultValue, selectorFamily } from "recoil";
import { TypedVariables } from "components/templates/dataGridTable/serverSide/types";

export interface ErrorReportFilterProps {
  errorReportStatus: string[];
}

export type FilterBuilderVariables = {
  filters: object;
};

export const issueDataGridQueryState = atom<TypedVariables<"Issue">>({
  key: "issueDataGridQueryState",
  default: {},
});

export const issueFilterAtom = atom<ErrorReportFilterProps>({
  key: "issueFilterAtom",
  default: {
    errorReportStatus: [],
  },
});

export const errorReportStatusAtom = atom<FilterItemStrings[]>({
  key: "errorReportStatus",
  default: [],
});

export const errorReportFilterAtom = atom<ErrorReportFilterProps>({
  key: "errorReportFilterAtom",
  default: {
    errorReportStatus: [],
  },
});

export const errorReportQueryFilterSelectorFamily = selectorFamily<string[], keyof ErrorReportFilterProps>({
  key: "errorReportQueryFilterSelectorFamily",
  get:
    (filterType) =>
    ({ get }) => {
      const filterValues = get(issueFilterAtom);
      return filterValues[filterType] ?? [];
    },

  set:
    (filterType) =>
    ({ set }, newValue) => {
      if (!newValue || newValue instanceof DefaultValue) return;
      if (newValue.length === 0 || newValue === undefined) {
        set(issueFilterAtom, (prev) => ({ ...prev, [filterType]: [] }));
      }
      if (newValue.length > 0) {
        set(issueFilterAtom, (prev) => ({ ...prev, [filterType]: newValue as string[] }));
      }
    },
});
